<template>
    <div class="clientPanl py-4">
        <div class="container pt-2">
           <h2 class="pb-2">TOP BRANDS</h2>
            <b-container class="text-center px-0">
                <div>
                    <VueSlickCarousel v-bind="settings">
                        <b-col class="relative"  v-for="(data,index) in bannerItems" :key="index">
							<b-link :href="data.url" >
                              <b-img-lazy v-bind="mainProps" class="border" :src="$root.MEDIAPATH+'banners/brands/'+data.img" fluid alt="Responsive image"></b-img-lazy>
							 </b-link>
                        </b-col>
						
						
						
                    </VueSlickCarousel>
                </div>
            </b-container>
        </div>
    </div>
</template>
<script >

import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'HeroCarousel',
    components: {VueSlickCarousel},
    data() {
        return {
            mainProps: {width: 500, height: 260},
            settings: {
                "arrows": true,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "infinite": true,
                "autoplay": false,
                "speed": 500,
                "cssEase": "linear",
                "slidesToShow": 5,
                "slidesToScroll": 1,
				"responsive": [
							{
							  "breakpoint": 1024,
							  "settings": {
								"slidesToShow": 3,
								"slidesToScroll": 3,
								"infinite": true,
								"dots": true
							  }
							},
							{
							  "breakpoint": 600,
							  "settings": {
								"slidesToShow": 2,
								"slidesToScroll": 2,
								"initialSlide": 2
							  }
							},
							{
							  "breakpoint": 480,
							  "settings": {
								"slidesToShow": 2,
								"slidesToScroll": 1
							  }
							}
						  ]
            },
			bannerItems:[		 
			 {img:"NewU-Logo.jpg",title:"Disguise",url:"/brand/newu"},
			 {img:"disguise.jpg",title:"Disguise",url:"/brand/disguise"},
			 {img:"embark.jpg",title:"embark",url:"/brand/embark"},
			 {img:"Badahair-Products.jpg",title:"Badahair-Products",url:"/brand/embark"},
			 {img:"clog-london.jpg",title:"clog-london",url:"/brand/clog-london"},
			 {img:"Jaquline_USA.jpg",title:"Jaquline_USA",url:"/brand/jaquline-usa"},
			 {img:"minu.jpg",title:"minu",url:"/brand/minu"},
			 {img:"myra-veda.jpg",title:"minu",url:"/brand/myra-veda"},
			 
			 ],
        }
    },
}
</script>
<style lang="scss">
.clientPanl{
    .relative {
        position:relative;
    }
    .absolute {
        position: absolute;
        bottom: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        left: 0;
        justify-content: center;
    }
    .border {
        border: 2px solid #565454 !important;
    }
		.slick{
			&-prev {
			  /*left: 3% !important;*/
			  top: 45% !important;
			
				width: 25px;
				height: 25px;
				background-color: #FFF;
				box-shadow: #bbb 0px 0px 6px;
				border-radius: 100px;
				
			  &:before{ 					
					content: 'prev'; 
					font-family: swiper-icons;
					color: #683581;
					font-size: 15px;
					font-weight: 700;
				}
				
			  
			}
			&-next {
			 /* right: 3% !important;*/
				top: 45% !important;
				
				width: 25px;
				height: 25px;
				background-color: #FFF;
				box-shadow: #bbb 0px 0px 6px;
				border-radius: 100px;

				&:before{ 	
						content: 'next'; 
						font-family: swiper-icons;
						color: #683581;
						font-size: 15px;
						font-weight: 700;
					}
				
			} 
		
		}
	
	}
</style>